export default "__VITE_ASSET__B$q4lQdK__"